<div class="trinka_cloud_wrap">
    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-8">
                                    <h1>Enhance Your Academic Writing</h1>
                                    <p>Sogang University, in partnership with Trinka, provides university-wide free access to Trinka’s advanced AI writing assistant built for academic and technical writing. This collaboration aims to enhance students' academic writing, improve the quality of their writing, and help them achieve their academic goals with ease.</p>
                                    <div class="btn-group justify-content-center mt-4">
                                        <a href="https://cloud.trinka.ai/" class="filled-btn" type="button">Claim Your Premium Access</a>
                                        
                                    </div>
                                    <small class="d-block mt-1">*Register with your university email id</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="section-how-it-works section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>How It Works</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <ul>
                    <li>
                        <div class="login_circle_section">
                            <img src="../../../assets/images/RegisterAndLogin.png" alt="register">
                        </div>
                        <h3>Register / Login<br/>&nbsp;</h3>
                    </li>
                    <li>
                        <div class="arrow">
                            <img src="../../../assets/images/person-arrow.png" alt="arrow" class="img-fluid" />
                        </div>
                    </li>
                    <li>
                        <div class="login_circle_section">
                            <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="import">
                        </div>
                        <h3>Type or import<br/> files</h3>
                    </li>
                    <li>
                        <div class="arrow">
                            <img src="../../../assets/images/person-arrow.png" alt="arrow" class="img-fluid" />
                        </div>
                    </li>
                    <li>
                        <div class="login_circle_section">
                            <img src="../../../assets/images/improveYourWriting_icon.png" alt="writing">
                        </div>
                        <h3>Improve your writing</h3>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<div class="cloud_key_features section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>About Trinka</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka goes beyond basic grammar and spelling to provide advanced writing suggestions to improve the manuscripts, thesis, dissertations, research papers, or any document.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="../../../assets/images/grammar-checker-icon.svg" alt="Grammar Checker" />
                    <h3>Grammar and Spelling<br/> Checks</h3>
                    <p>Correct complex grammar errors to make your writing clear.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="../../../assets/images/AddtoDictionary.svg" alt="writing enhancement">
                    <h3>Advanced Writing Enhancements</h3>
                    <p>Refine your academic tone and enrich vocabulary to meet scholarly standards.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    
                    <img src="../../../assets/images/error-highlight-icon.svg" alt="Technical Corrections">
                    <h3>Technical Corrections<br/>&nbsp;</h3>
                    <p>Get contextual subject-specific corrections to improve your writing.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/paraphraser-icon.svg" alt="Paraphraser">
                    <h3>Paraphraser<br/>&nbsp;</h3>
                    <p>Receive suggestions to create coherent paraphrases while retaining the original meaning</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/autoFileEdit_icon.svg" alt="Proofread file">
                    <h3>Proofread <br/>File</h3>
                    <p>Proofread your .docx & .tex files while preserving original formatting and code integrity.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/ConsistencyCheck_icons.png" alt="consistency check">
                    <h3>Consistency Check</h3>
                    <p>Fix hard-to-find inconsistencies in lengthy documents for a professional finish.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="whiteListing section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Why Use Trinka?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>Improve Academic Writing <span><img src="../../../assets/images/icons/growth.png" alt="Academic Writing" /></span></h4>
                        <p>Get suggestions to enhance your writing and make it more impactful.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>Save Time <span><img src="../../../assets/images/icons/browser.png" alt="Save Time" /></span></h4>
                        <p>Spend less time proofreading and more time on research.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>Boost Your Grades <span><img src="../../../assets/images/icons/Icon_Pass_02.png" alt="boost grades" /></span></h4>
                        <p>Submit well-polished assignments and papers.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>Free Premium Access <span><img src="../../../assets/images/icons/premium.png" alt="Premium Access" /></span></h4>
                        <p>Enjoy premium features at no cost, exclusively for Sogang University students.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="allAboutTrinkaCredit list-wrapper-style-2 section-pd">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="aboutTrinkaCreditHeading list-wrapper-content-2 p-0">
                    <div class="trinka-title mb-0">
                        <h2>Simple Steps to Start Using Trinka</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <ul>
                            <li><b>Sign Up:</b> Click the “Sign-up” button below and create a Trinka account using your Sogang University email address.</li>
                            <li><b>Confirm Premium Activation:</b> You will receive an email asking to confirm your activation of free Trinka Premium Subscription under the University Plan.</li>
                            <li><b>Start Writing:</b> Click on “Activate Premium” and log in to start writing better with Trinka AI.</li>
                        </ul>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/" class="filled-btn">Sign Up Now</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="api_img text-center">
                    <img src="../../../assets/images/word-add-in-banner.svg" loading="lazy" decoding="async" class="img-fluid" alt="inclusive language check api" />
                </div>
            </div>
            
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">Resources to Get You Started</h3>
                    <p class="text-white w-100">To help you make the most of Trinka, below is a detailed process document and step-by-step video guide. These resources will guide you through using Trinka effectively.</p>
                    <div class="btn-group mt-4 align-items-center justify-content-center">
                        <a href="#" class="white-btn" target="_blank"><svg width="28px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12.5535 16.5061C12.4114 16.6615 12.2106 16.75 12 16.75C11.7894 16.75 11.5886 16.6615 11.4465 16.5061L7.44648 12.1311C7.16698 11.8254 7.18822 11.351 7.49392 11.0715C7.79963 10.792 8.27402 10.8132 8.55352 11.1189L11.25 14.0682V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V14.0682L15.4465 11.1189C15.726 10.8132 16.2004 10.792 16.5061 11.0715C16.8118 11.351 16.833 11.8254 16.5535 12.1311L12.5535 16.5061Z" fill="#fff"></path> <path d="M3.75 15C3.75 14.5858 3.41422 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V15.0549C2.24998 16.4225 2.24996 17.5248 2.36652 18.3918C2.48754 19.2919 2.74643 20.0497 3.34835 20.6516C3.95027 21.2536 4.70814 21.5125 5.60825 21.6335C6.47522 21.75 7.57754 21.75 8.94513 21.75H15.0549C16.4225 21.75 17.5248 21.75 18.3918 21.6335C19.2919 21.5125 20.0497 21.2536 20.6517 20.6516C21.2536 20.0497 21.5125 19.2919 21.6335 18.3918C21.75 17.5248 21.75 16.4225 21.75 15.0549V15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15C20.25 16.4354 20.2484 17.4365 20.1469 18.1919C20.0482 18.9257 19.8678 19.3142 19.591 19.591C19.3142 19.8678 18.9257 20.0482 18.1919 20.1469C17.4365 20.2484 16.4354 20.25 15 20.25H9C7.56459 20.25 6.56347 20.2484 5.80812 20.1469C5.07435 20.0482 4.68577 19.8678 4.40901 19.591C4.13225 19.3142 3.9518 18.9257 3.85315 18.1919C3.75159 17.4365 3.75 16.4354 3.75 15Z" fill="#fff"></path> </g></svg> Process Document</a>
                        <a href="#" class="white-btn" target="_blank"><svg width="28px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21.4086 9.35258C23.5305 10.5065 23.5305 13.4935 21.4086 14.6474L8.59662 21.6145C6.53435 22.736 4 21.2763 4 18.9671L4 5.0329C4 2.72368 6.53435 1.26402 8.59661 2.38548L21.4086 9.35258Z" fill="#fff"></path> </g></svg> Step-by-Step Videos</a>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Testimonials</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="c-card testimonial-card">
                    <svg width="80px" height="80px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#6f2496"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path fill="none" d="M0 0h24v24H0z"></path> <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"></path> </g> </g></svg>
                    <p>Trinka has significantly improved the quality of my research papers. The suggestions are spot on!</p>
                    <div class="ts-name">
                        <h6>[Student Name]</h6>
                        <small>[Program Name]</small>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 dflex">
                <div class="c-card testimonial-card">
                    <svg width="80px" height="80px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#6f2496"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path fill="none" d="M0 0h24v24H0z"></path> <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"></path> </g> </g></svg>
                    <p>Using Trinka has saved me countless hours. I feel more confident submitting my work now.</p>
                    <div class="ts-name">
                        <h6>[Student Name]</h6>
                        <small>[Program Name]</small>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div>